import { createAction } from 'redux-actions'
import * as constants from './constants'

export const setLoaded = createAction(constants.SET_LOADED)
export const timedOut = createAction(constants.TIMED_OUT)
export const setPending = createAction(constants.SET_PENDING)

export const enrollUserInExperiment = createAction(constants.ENROLL_USER_IN_EXPERIMENT)



// WEBPACK FOOTER //
// ./src/modules/experiment/actions.js